
import * as Action from "../../shared/timeclock/actions";
import { OfflineStampRequest } from "../../shared/timeclock/services/api";

export function offline(state: OfflineStampRequest[], action: {type: string, stamp: OfflineStampRequest}): OfflineStampRequest[] {

    if (state === undefined) {
        return [];
    }

    switch (action.type) {
        case Action.OFFLINE_STAMP:
            return [action.stamp, ...state];
        case Action.OFFLINE_CLEAR:
            return [];
    }

    return state;
}
